import React from 'react';
import PropTypes from 'prop-types';

import { getStep } from '../../api';

import ProductRadio from '../../ProductRadio';

class Finish extends React.PureComponent {
  state = {
    products: [],
  };

  componentDidMount() {
    if (!this.props.values.variation) {
      this.props.setError('variation', 'required');
    }

    getStep({ ...this.props.values, step: this.props.step }, this.props.setLoading)
      .then(
        (res) => {
          this.setState({
            products: res,
          });
        },
        (error) => {
          console.log(error);
          this.props.setError('generic', error);
        }
      );
  }

  componentWillUnmount() {
    if (this.props.errors.variation) {
      this.props.setError('variation');
    }
  }

  handleChange = (name, value) => {
    if (!value) {
      this.props.setError(name, 'required');
    } else {
      this.props.setError(name);
    }

    const product = this.state.products.find((product) => product.id === value);
    this.props.setValue('variation_price', product.price.raw);
    this.props.setValue('meter_price', product.price.string);
  };

  render() {
    return (
      <div id="mtm-finish" className="row small-up-2 medium-up-3 mediumlarge-up-4 large-up-3 xlarge-up-4 mtm-grid">
        {this.state.products.map((product) => (
          <ProductRadio
            key={product.id}
            fieldName="variation"
            value={product.id}
            name={product.name}
            image={product.image.html}
            price={product.price.string}
            onChange={this.handleChange}
          />
        ))}
      </div>
    );
  }
}

Finish.propTypes = {
  step: PropTypes.number.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default Finish;





// WEBPACK FOOTER //
// ./src/Step/steps/Finish.js